export default "__VITE_ASSET__fra7j9rI__"